import { useState } from "react";
import { throwResponseError } from "../../../../utils/api-error-utils";
import { getAuthParams } from "../../../../utils/pacto-rebates-utils";
import { formatDeclineNetSalesResponse } from "../../../utils/decline-net-sales-utils";

export function useDeclineNetSalesById() {
    const [declineNetSales, setDeclineNetSales] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function fetchDeclineNetSalesById(declineNetSalesId) {
        if (!declineNetSalesId) {
            setDeclineNetSales(null);
            setError("Não foi possível identificar a penalidade por queda em Net Sales (Grupo).");

            return {
                ok: false,
                reason: "validation",
                error: "Não foi possível identificar a penalidade por queda em Net Sales (Grupo)."
            };
        }

        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/penalidades-queda-grupo/${encodeURIComponent(declineNetSalesId)}`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível carregar os dados da penalidade por queda em Net Sales (Grupo)."
                );
            }

            const data = await response.json();

            const declineNetSalesData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedDeclineNetSales = formatDeclineNetSalesResponse(declineNetSalesData);

            setDeclineNetSales(formattedDeclineNetSales);

            return {
                ok: true,
                declineNetSales: formattedDeclineNetSales
            };
        } catch (requestError) {
            setDeclineNetSales(null);
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        declineNetSales,
        loading,
        error,
        fetchDeclineNetSalesById
    };
}